import { Lap, LapRaw } from "./lap";
import { RaceProgressRegistration } from "./race_progress_registration";

export class InfoLapModalData {
    lap: Lap;
    lapNew: Lap;
    indexLap: number;
    competitor: RaceProgressRegistration

    constructor(lap: Lap, indexLap: number, competitor: RaceProgressRegistration) {
        this.lap = lap;
        this.lapNew = new Lap(lap as unknown as LapRaw);
        this.indexLap = indexLap;
        this.competitor = competitor;
    }

}